import { render, staticRenderFns } from "./informacionOferta.vue?vue&type=template&id=71a4767a&"
import script from "./informacionOferta.vue?vue&type=script&lang=js&"
export * from "./informacionOferta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports